import React from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";

interface HeaderProps extends BaseCompProps {
  attr?: any;
}
const { useTranslation } = Hooks;
const Header: React.FC<HeaderProps> = ({ className }) => {
  const t = useTranslation();
  return (
    <div className={cx(styles.header, className)}>
      <div className={styles["header_top"]}>
        <h6>
          <span>{t("account.Authentication")}</span>
        </h6>
        <p>{t("account.PleaseNoteThatTheAuthentication")}</p>
      </div>
    </div>
  );
};
export default observer(Header);
